export const IW_CONTAINER_NAME = 'main';

export const breakpoints = {
  xl: `(min-width: 1200px)`,
  lg: `(min-width: 800px) and (max-width: 1199px)`,
  md: `(min-width: 600px) and (max-width: 799px)`,
  sm: `(max-width: 599px)`,
} as const;

export const media = {
  xl: `@media screen and ${breakpoints.xl}`,
  lg: `@media screen and ${breakpoints.lg}`,
  md: `@media screen and ${breakpoints.md}`,
  sm: `@media screen and ${breakpoints.sm}`,
  isMobile: `@media screen and (max-width: 599px)`,

  iwDesktop: `@media screen and (min-width: 1200px)`,
  iwNotDesktop: `@media screen and (max-width: 1199px)`,
  iwMobile: `@media screen and (max-width: 800px)`,
  iwMobileLandscape: `@media screen and (max-height: 550px)  and (max-width: 1000px) and (orientation: landscape) `,
  iwMobileOrLandscape: `@media screen and (max-width: 699px), screen and (max-height: 550px)  and (max-width: 1000px) and (orientation: landscape)`,
  iwNotMobile: `@media screen and (min-width: 700px)`,
  iwContainer: {
    xl: `@container ${IW_CONTAINER_NAME} (width <= 1440px)`,
    l: `@container ${IW_CONTAINER_NAME} (width <= 1200px)`,
    m: `@container ${IW_CONTAINER_NAME} (width <= 800px)`,
    s: `@container ${IW_CONTAINER_NAME} (width <= 600px)`,
    xs: `@container ${IW_CONTAINER_NAME} (width <= 520px)`,
    xxs: `@container ${IW_CONTAINER_NAME} (width <= 390px)`,
  },

  /**
   * @deprecated Use media.xl
   */
  desktop: `@media screen and (min-width: 992px)`,
  /**
   * @deprecated Use media.sm
   */
  mobile: `@media screen and (max-width: 991px)`,
} as const;
